import React from 'react';
import { Divider, Typography } from '@mui/material';
import morich from '../../../../../images/Agri-info/crops/marich_মরিচ.jpg';
import useDocumentTitle from '../../../../../hooks/useDocumentTitle';

const MorichInfo = () => {

    // dynamic title
    useDocumentTitle("মরিচ");

    return (

        <div className=" rounded-3 bg-white my-4 px-5">
            <Typography
                sx={{
                    textAlign: "center",
                    pb: 2,
                    pt: 3,
                    fontWeight: 600,
                    color: 'rgb(37, 36, 36, 0.83)'
                }}
                variant="h3"
                noWrap
                component="div"
            >
                মরিচ
            </Typography>
            <Divider />

            <div className="card mt-4 mb-3 border-0 rounded-0">
                <div className="row g-0">
                    <div className="col-md-4">
                        <img src={morich} className="img-fluid rounded-0 h-100" alt="..." />
                    </div>
                    <div className="col-md-8">
                        <div className="card-body text-start ">
                            <p className="card-text fw-bold">পুষ্টিমূল্য :</p>
                            <p className="card-text">শুকনো মরিচে আমিষ, প্রচুর পরিমাণে ক্যালসিয়াম ও ভিটামিন ‘সি’ থাকে।</p>

                            <p className="card-text fw-bold">ভেষজ গুণঃ </p>
                            <p className="card-text">নিয়মিতভাবে কাঁচা মরিচ খেলে মুখে ‘ঘা’ হয় না।
                                ব্যবহারঃ রান্না-বান্না ও মুখরোচক খাবার তৈরি ছাড়াও মরিচ বিভিন্ন ধরনের আচার তৈরির উপাদান হিসেবে ব্যবহার হয়। অনেকে মরিচের আচারও করে থাকেন।</p>

                            <p className="card-text fw-bold">উপযুক্ত জমি ও মাটিঃ </p>
                            <p className="card-text">প্রচুর আলো-বাতাস এবং  পানি, সেচ ও নিকাশের ব্যবস্থা আছে এমন দো-আঁশ মাটি মরিচ চাষের জন্য উপযোগী।</p>

                        </div>
                    </div>
                </div>
            </div>

            <div className='text-start pb-5'>

                <p className="card-text fw-bold">জাত পরিচিতিঃ</p>
                <p className="card-text">ঝাল ও মিষ্টি এ ধরনের মরিচ দেখা যায়। ঝাল মরিচের মধ্যে বগুড়া, চাঁদপুরী, ফরিদপুরী উল্লেখযোগ্য। এছাড়া কামরাংগা, আকালী ও কালো মরিচ খুব ঝাল।</p>

                <p className="card-text fw-bold">চারা তৈরিঃ </p>
                <p className="card-text">জমি ভালভাবে চাষ ও ও মই দিয়ে ও আগাছা বাছাই করে ৩১ মিটার আকারের বীজতলা করে সেখানে বীজ বপন করা হয়। শীতকালের জন্য ভাদ্র-আশ্বিণ মাসে ও বর্ষা মৌসুমের জন্য ফাল্গুন-চৈত্র মাসে বীজতলায় বীজ বপন করা হয়। চারা ১০ সে.মি. উঁচু হলে রোপণের উপযোগী হয়।</p>

                <p className="card-text fw-bold">চারা রোপণঃ </p>
                <p className="card-text">আগাছা পরিষ্কার করে ৪-৫ টি চাষ ও মই দিয়ে জমি প্রস্তুতির পর চারা রোপণ করা হয়। চারা রোপণে সারি থেকে সারির দূরত্ব ৬০-৭০ সে.মি. ও চারা থেকে চারার দূরত্ব ৩০-৪০ সে.মি. রাখা হয়। চারা বিকেলে লাগাতে হবে এবং ২-৩ দিন সকাল বিকাল পানি দিতে হবে।আগাছা পরিষ্কার করে ৪-৫ টি চাষ ও মই দিয়ে জমি প্রস্তুতির পর চারা রোপণ করা হয়। চারা রোপণে সারি থেকে সারির দূরত্ব ৬০-৭০ সে.মি. ও চারা থেকে চারার দূরত্ব ৩০-৪০ সে.মি. রাখা হয়। চারা বিকেলে লাগাতে হবে এবং ২-৩ দিন সকাল বিকাল পানি দিতে হবে।</p>

                <p className="card-text fw-bold">সার ব্যবস্থাপনাঃ </p>
                <p className="card-text">মরিচের জমিতে প্রতি হেক্টরে গোবর ১০ টন, ইউরিয়া ২৫০ কেজি, টিএসপি ২০০ কেজি এবং এমওপি সার ১৫০ কেজি প্রয়োগ করা হয়। জমি তৈরির সময় সমুদয় গোবর, টিএসপি ও ৫০ কেজি  এমওপি সার প্রয়োগ করা হয়। চারা রোপণের ২৫ দিন পর ৮৪ কেজি ইউরিয়া ও ৩৪ কেজি এমওপি সার প্রথম উপরি প্রয়োগ করা হয়। লাগানোর ৫০ দিন পর ২য় ও ৭০ দিন পর তৃতীয় কিস্তির উপরি সার প্রয়োগ করা হয়। ২য় ও ৩য়   কিস্তির প্রতিবারে ৮৩ কেজি ইউরিয়া ও ৩৩ কেজি এমওপি সার প্রয়োগ করা হয়।</p>

                <p className="card-text fw-bold">সেচ ও আগাছা ব্যবস্থাপনাঃ </p>
                <p className="card-text">জমিতে রসের অভাব হলে সেচ দিতে হবে ও পানি নিকাশের ব্যবস্থা রাখতে হবে। আগাছা দেখা দিলে তা পরিষ্কার করতে হবে এবং উপরি সার প্রয়োগের সময় কোদাল দিয়ে কুপিয়ে আলগা করে দিতে হবে।</p>

                <p className="card-text fw-bold">পোকা </p>
                <p><b>পোকার নাম : </b>সাদা মাছি</p>
                <p className="card-text fw-bold">ভূমিকা :  </p>
                <p className="card-text">খুব ছোট আকারের এ পোকা পাতার রস চুষে খায়। ফলে গাছের বাড়বাড়তি ব্যহত হয়। তাছাড়া এ পোকা কালো সুটি মোল্ড নামক ছত্রাক পাতায় জন্মাতে  সহায়তা করে এবং ভাইরাস রোগ ছড়ায়।</p>

                <p className="card-text fw-bold">পোকা চেনার উপায় : </p>
                <p className="card-text">সাদা রংয়ের এ পোকা গাছের পাতার নিচের দিকে থাকে। লম্বায় ১ মিলিমিটারের চেয়ে সামান্য বড়। গাছের পাতা সামান্য নাড়া দিলে উড়ে চলে যায়। এ সকল পোকার শরীর সাদা মোম জাতীয় পদার্থ দ্বারা ঢাকা থাকে।</p>

                <p className="card-text fw-bold">ক্ষতির নমুনা :</p>
                <p className="card-text">
                    - পাতার নিচের দিক হতে প্রাপ্ত বয়স্ক ও অপ্রাপ্ত বয়স্ক (নিম্ফ)  পোকা পাতার রস চুষে খায় ফলে পাতা কুঁচকে যায় এবং গাছের বৃদ্ধি ব্যাহত হয়।   <br />
                    - আক্রমণে প্রথমে পাতায় সাদা বা হলদেটে রং দেখা যায় পরে দাগগুলো একত্রে হয়ে সবুজ শিরাসহ পাতা হলুদ হয়ে যায়।  <br />
                    - এ পোকা খাওয়ার সময় আঠালো মিষ্টি রস  নি:সরণ করে বিধায় ঐ আঠাতে কালো ছত্রাক জন্মাতে সহায়তা করে।  <br />
                    - এ পোকা ভাইরাস রোগ ছড়ায়।</p>
                <p><b>অনুকুল পরিবেশ :  </b>উষ্ণ ও শুষ্ক আবহাওয়া এ পোকা বিস্তারের জন্য সহায়ক।</p>

                <p className="card-text fw-bold">জীবন চক্র : </p>
                <p className="card-text">এ পোকা সাধারনত পাতার নিচের দিকে অতি ক্ষুদ্র সাদা ডিম পাড়ে। ডিম পরে বাদামী রং ধারণ করে ও ৩-১৭ দিন পর ডিম ফুটে নিম্ফ (বাচ্চা ) বের হয়। বাচ্চা সবুজাভ সাদা, ২-৬ সপ্তাহ নিম্ফ অবস্থায় থেকে  পূর্ণাঙ্গ পোকায় পরিণত হয়। পূর্নাঙ্গ পোকা ১০-১৫ দিন বাঁচে।</p>

                <p className="card-text fw-bold">ব্যবস্থাপনা : </p>
                <p className="card-text">- হলুদ রংয়ের আঠালো ফাঁদ ব্যবহার করতে হবে।<br /> - প্রতি লিটারের ৫ গ্রাম কাপড় কাঁচা সাবান মিশিয়ে স্প্রে করতে হবে।<br />- অনুমোদিত কীটনাশক নির্ধারিত মাত্রায় ব্যবহার করতে হবে।</p>

                <p className="card-text fw-bold">থ্রিপস</p>
                <p><b>পোকার নাম : </b>থ্রিপস</p>
                <p className="card-text fw-bold">ভূমিকা : </p>
                <p className="card-text">এটি একটি ক্ষুদ্র পোকা। আক্রমণ বাহির হতে বোঝা যায় না বিধায় ক্ষতির সমূহ সম্ভাবনা থাকে। সুতরাং মাঝে মাঝে ক্ষেত পরিদর্শন করে ফসলের অবস্থা দেখে আগে থেকেই ব্যবস্থা নিতে হবে।</p>

                <p className="card-text fw-bold">পোকা চেনার উপায় : </p>
                <p className="card-text">থ্রিপস অতি ক্ষুদ্র একটি পোকা যা খালি চোখে কোন মতে দেখা যায়। এ পোকা পাতার রস চুষে খায়। ফলে অধিক আক্রমণে পাতা কুঁচতে যায় এমনকি গাছ থেকে কোন ফুল ফল নাও আসতে পারে। এ পোকা ভাইরাস রোগও ছড়ায়।</p>

                <p className="card-text fw-bold">ক্ষতির নমুনা</p>
                <p className="card-text">
                    - নিম্ফ (বাচ্চা )ও পূনাঙ্গ পাতার রস চুষে খায় বলে পাতা কুঁকড়িয়ে যায় এবং অনেকটা  নৌকার মত দেখায়।  <br />
                    - পোকার আক্রমনে পাতা বাদামী রং ধারন করে।<br />
                    - নতুন ও পুরাতন উভয় পাতায় আক্রমন করে।</p>
                <p><b>অনুকুল পরিবেশ : </b>উষ্ণ ও শুষ্ক আবহাওয়া ।</p>

                <p className="card-text fw-bold">জীবন চক্র : </p>
                <p className="card-text">পূর্ণ বয়স্ক পোকা ৪৫-৫০টি ডিম পাড়ে। ৫-৬ দিনে ডিম থেকে নিম্ফ (বাচ্চা) বের হয় এবং নিম্ফ ৭-৮ দিন পর পূর্নাঙ্গ পোকায় পরিণত হয়। র্পূনাঙ্গ পোকা ৩১ দিন পর্যন্ত বাঁচে। পাতা নাড়াচাড়া করলে এরা উড়ে পালায় ।</p>

                <p className="card-text fw-bold">ব্যবস্থাপনা :</p>
                <p className="card-text"> - সাদা রংয়ের আঠালো ফাঁদ ব্যবহার<br />
                    - মাকড়সা এ পোকা খায় বিধায় এর সংখ্যা বাড়ানো গেলে সহজেই থ্রিপস দমন করা যায়।<br />
                    - অনুমোদিত কীটনাশক সঠিক মাত্রায় প্রয়োগ ।</p>

                <p className="card-text fw-bold">পাতা পঁচা</p>
                <p><b>রোগের নাম : </b>পাতা পঁচা</p>
                <p><b>রোগের কারণ : </b>চুয়ানিফোরা নামক ছত্রাকের আক্রমনে এ রোগ হয়।</p>
                <p className="card-text fw-bold">ভূমিকা :</p>
                <p className="card-text">ক্ষেতে আক্রমণ বেশী হলে সম্পূর্ণ ফসল নষ্ট হয়ে যাবার সম্ভাবনা আছে। এ কারনে রোগের আক্রমনের শুরু থেকেই  সাবধানতা অবলম্বন করা উচিত।</p>

                <p className="card-text fw-bold">ক্ষতির নমুনা : </p>
                <p className="card-text">চারা ও বয়স্ক গাছের শাখা প্রশাখা, পাতা ফুল ও ফল এ রোগে আক্রান্ত হয়। প্রথমে পাতায় পানি ভেজা দাগ দেখা যায়। পরে এ দাগ বৃদ্ধি পায় ও আক্রান্ত অংশ বিবর্ণ হয়ে কালচে রং ধারন করে এবং পাতা দ্রুত পঁচে যায়। অনুকুল পরিবেশে ৫-৭ দিনের মধ্যে সম্পূর্ণ গাছ মরে যেতে পারে।</p>
                <p><b>অনুকুল পরিবেশ : </b>উচ্চ তাপ মাত্রা ও স্যাঁত স্যাঁতে আবহাওয়ায় এ রোগ দ্রুত ছড়ায় ।</p>
                <p><b>বিস্তার : </b>বায়ু , আক্রান্ত অংশের মাধ্যমে এ রোগ ছড়ায়।</p>

                <p className="card-text fw-bold">ব্যবস্থাপনা : </p>
                <p className="card-text">- ফসলের পরিত্যাক্ত অংশ নষ্ট করতে হবে।<br /> - গাছ আক্রান্ত হওয়া মাত্রই অনুমোদিত ছত্রাক নাশক স্প্রে করতে হবে।</p>

                <p className="card-text fw-bold">লিফ কার্ল</p>
                <p><b>রোগের নাম : </b>লিফ কার্ল</p>
                <p><b>রোগের কারণ :</b> একপ্রকার ভাইরাস</p>
                <p className="card-text fw-bold">ভূমিকা : </p>
                <p className="card-text">যে কোন বয়সের গাছ আক্রান্ত হতে পারে তবে বয়স্ক গাছই বেশী আক্রান্ত হয়। পাতা কুঁকড়িয়ে যায় বলে গাছের সাধারণ বৃদ্ধি ব্যহত হয় ও ফলন কমে যায়।</p>

                <p className="card-text fw-bold">ক্ষতির নমুনা :</p>
                <p className="card-text">
                    - আক্রান্ত গাছের পাতা কুঁকড়িয়ে যায় ও সাধারণ পাতা অপেক্ষা পুরু হয়।  <br />
                    - গাছের পর্ব মধ্য ছোট হয় ও গাছ খাট আকারের হয়।<br />
                    - ফুল ও ফল ধারণ ক্ষমতা কমে যায়।<br />
                    - ভাইরাস আক্রান্ত গাছ মরে যায় না তবে পুনরায় স্বাভাবিক ও হয় না ।</p>
                <p><b>অনুুকুল পরিবেশ :</b> বিকল্প পোষকের উপস্থিতি</p>
                <p><b>বিস্তার : </b>পোকা দ্বারা এ রোগের বিস্তার ঘটে।</p>

                <p className="card-text fw-bold">দমন : </p>
                <p className="card-text">- আশে পাশের সোলানেসি পরিবারের অন্যান্য পোষক উদ্ভিদ ধ্বংশ করতে হবে।<br />
                    - অনুমোদিত কীটনাশক সঠিক মাত্রায় প্রয়োগ করতে হবে।</p>

                <p className="card-text fw-bold">ফসল সংগ্রহঃ </p>
                <p className="card-text">ফুল আসার পর ১৫-২০ দিনের মধ্যে কাঁচা মরিচ তোলা হয়। তবে মরিচের রং লাল হলে তুলে রোদে শুকিয়ে সংরক্ষণ করা যায়। প্রতি হেক্টরে ফলন কাঁচা ১০-১১ টন ও শুকনো ১.৫-২.০ টন।</p>

            </div>
        </div >


    );
};

export default MorichInfo;